module.exports = __webpack_public_path__ + "static/media/info.0bb3578f.svg";